module.exports = __webpack_public_path__ + "static/img/CY.189e75ea.png";